import request from '@/config/axios'

export const getAiMemoryPage = (params: any) =>
  request.get({ url: '/bosscircle/ai-memory/page', params })
export const getAiMemory = (id: number) =>
  request.get({ url: '/bosscircle/ai-memory/get', params: { id } })
export const clearAiMemory = (data: any) =>
  request.put({ url: '/bosscircle/ai-memory/clear', data })
